import { HStack, Text } from "@chakra-ui/react";
import { getScoreBucket } from "../helpers/scoreBuckets";
import defaultLabels from "../labels.default";

/**
 * Shared score/status badge used on both the candidate list (Faza 8) and
 * the candidate detail "Ocena" tab (Faza 9) -- one place owns the fixed
 * color-range logic so the two views can never drift apart.
 */
const ScoreBadge = ({ evaluation, labels: labelOverrides, size = "sm" }) => {
    const labels = { ...defaultLabels, ...labelOverrides };
    const bucket = getScoreBucket(evaluation);

    if (!bucket) {
        return <Text color="text.grey" fontSize={size} fontStyle="italic">{labels.noEvaluation}</Text>;
    }

    return (
        <HStack gap={2}>
            {!bucket.dominant && evaluation.scorePercent != null && (
                <Text color="white" fontSize={size} fontWeight={600}>{Math.round(evaluation.scorePercent)}%</Text>
            )}
            <Text color={bucket.color} fontSize={size} fontWeight={600}>{labels[bucket.labelKey]}</Text>
        </HStack>
    );
};

export default ScoreBadge;
